<template>
  <div>
    <Nav current="我的公司"></Nav>
    <div class="content">
      <div class="title">添加编号</div>
      <div class="form">
        <div class="form_item">
          <span class="item_name">编号</span>
          <input type="text" ref="number" v-model="dataList.name" />
          <span class="xing-huang">* 为必填项</span>
        </div>
        <div class="form_item">
          <span class="item_name indent">姓名</span>
          <input type="text" v-model="dataList.alias" />
        </div>
        <div class="form_item">
          <span class="item_name indent">使用者手机号</span>
          <input type="text" v-model="dataList.mobile" maxlength="11" onkeyup="value=value.replace(/[^\d]/g,'');"/>
          <span class="xing-lv">* 为必填项</span>
        </div>
        <!-- 000新增登陆密码 -->
        <div class="form_item" v-if="!mobileFlag">
          <span class="item_name indent">登录密码</span>
          <input type="text" v-model="dataList.pwd" minlength="6"/>
        </div>
        <div class="form_item">
          <span class="item_name indent">部门</span>
          <input type="text" v-model="dataList.departmentName" disabled />
          <span class="btn" ref="department" @click="showDisappearDepart"
            >选择</span
          >
          <span class="btn clear" @click="clearParent">清除</span>
        </div>
        <div class="form_item">
          <span class="item_name indent">角色</span>
          <input type="text" v-model="dataList.roleName" disabled />
          <span class="btn" ref="role" @click="showDisappearRole">选择</span>
          <span class="btn clear" @click="clearParent('role')">清除</span>
        </div>
        <div class="form_item">
          <span class="item_name indent">备注</span>
          <input type="text" v-model="dataList.remark" />
        </div>

        <div class="form_item" style="display:none;">
          <span class="item_name indent">编号是否同步第三方</span>
          <div class="radio">
            <template>
              <el-radio v-model="dataList.shadowTokenSignal" label="false"
                >否</el-radio
              >
              <el-radio v-model="dataList.shadowTokenSignal" label="true"
                >是</el-radio
              >
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹框  -->
    <div class="ec_tip none" ref="none" v-if="btnType == 0">
      <div class="ec-title">
        请选择部门 <span id="close" @click="disappear">x</span>
      </div>
      <div class="ec-cont">
        <input type="text"
          placeholder="查找部门"
          v-model="name"
          @keyup.enter="getSearchList" />
        <i
          class="el-icon-search"
          @click="getSearchList"
        ></i>
      </div>
      <div class="tree" id="tree">
        <vxe-table
          :show-header="false"
          v-if="tapTable == 1"
          border="none"
          resizable
          ref="xTree"
          row-id="id"
          :height="tableHeight"
          highlight-hover-row
          highlight-current-row
          :loading="loading"
          :tree-config="{
            lazy: islazy,
            hasChild: 'hasChild',
            children: 'children',
            loadMethod: loadChildrenMethod,
          }"
          @radio-change="radioChangeEvent"
          :radio-config="{labelField: 'name', trigger: 'row', highlight: true}"
          :data="tableData.data"
        >
          <vxe-table-column type="radio" field="name" title="名称" width="440" tree-node>
            <template #default="{ row }">
              <span class="custom-tree-node">
                <span v-html="row.name.replace(new RegExp(name,'g'),`<font style='color:red'>${name}</font>`)" />
              </span>
            </template>
          </vxe-table-column>
        </vxe-table>
        <vxe-table
          :show-header="false"
          v-if="tapTable == 2"
          border="none"
          resizable
          ref="xTrees"
          row-id="id"
          :height="tableHeight"
          highlight-hover-row
          highlight-current-row
          :loading="loading"
          :tree-config="{
            expandAll: true, //展开所有子级
            hasChild: 'hasChild',
            children: 'children',
            loadMethod: loadChildrenMethod1,
          }"
          @radio-change="radioChangeEvent"
          :radio-config="{labelField: 'name', trigger: 'row', highlight: true}"
          :data="tableData.data"
        >
          <vxe-table-column type="radio" field="name" title="名称" width="440" tree-node>
            <template #default="{ row }">
              <span class="custom-tree-node">
                <span v-html="row.name.replace(new RegExp(name,'g'),`<font style='color:red'>${name}</font>`)" />
              </span>
            </template>
          </vxe-table-column>
        </vxe-table>
        <!-- <el-tree
          :default-expand-all="isExpandAll"
          :key="treeKey"
          :data="parentList"
          show-checkbox
          node-key="id"
          :expand-on-click-node="false"
          check-strictly
          current-node-ke
          ref="treeForm"
          :default-checked-keys="[checkedId]"
          :props="defaultProps"
          @check-change="handleNodeClick1"
        >
          <span slot-scope="{ node }" class="custom-tree-node">
            <span v-html="node.label.replace(new RegExp(name,'g'),`<font style='color:red'>${name}</font>`)" />
          </span>
        </el-tree> -->
      </div>
      <div class="ec-but">
        <input type="button" value="确定" @click="submitData1" />
      </div>
    </div>

    <div class="ec_tip none" ref="none" v-if="btnType == 1">
      <div class="ec-title">
        请选择角色 <span id="close" @click="disappear">x</span>
      </div>
      <div class="ec-cont">
        <input
          type="text"
          ref="input"
          placeholder="查找角色"
          v-model="name"
          @keyup.enter="searchTreeRole"
        /><i class="el-icon-search" @click="searchTreeRole"></i>
      </div>
      <div class="tree">
        <el-tree
          :data="roleList"
          show-checkbox
          node-key="checkedId"
          :default-checked-keys="[checkedId]"
          ref="treeForm"
          :props="defaultProps"
          @check-change="handleNodeClick2"
        >
          <transparent slot="scope"> </transparent>
          <!-- :default-checked-keys="checkedkeys" -->
          <!-- 选中一个  取消一个 -->
        </el-tree>
      </div>
      <div class="ec-but">
        <input type="button" value="确定" @click="submitData2" />
      </div>
    </div>
    <!-- 蒙层 -->
    <el-row class="el-row">
      <el-button type="primary" class="el-button btnSty" @click="addNumberInfo"
        >保存</el-button
      >
      <el-button class="el-button btnret" @click="retSuper">返回</el-button>
    </el-row>
    <div class="mask none" ref="none"></div>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      departmentNameTemp:'',
      departmentIdTemp:'',
      tableData: {
        data: [],
      },
      islazy: true, //是否懒加载
      treeNode: true,
      loading: false,
      selectRow: null, //当前选中的行
      tableHeight: 420,

      tapTable: 1,
      lazy: false,
      items: [],
      currentPage: 1,
      pageSize: 100000,
      parentId: "",
      name: "",
      chooseNode: null, // 当前节点
      resolve: null,
      showTree: true,

      treeKey: '',
      isExpandAll: false,//是否展开所有节点
      btnType: 0,
      disabledList: [],
      inputList: [],
      parentList: [],
      roleList: [],
      // shadowTokenSignal: "false",
      treeType: "",
      // name: "",
      dialogTableVisible: false,
      dataList: {
        name: "",
        alias: "",
        mobile: "",
        departmentId: "",
        departmentName: "",
        roleName: "",
        roleId: "",
        remark: "",
        shadowTokenSignal: "false",
        pwd:'',//登陆密码
      },
      departmentList: [],
      treeData: [],
      checkedId: "",
      defaultProps: {
        children: "children",
        label: "name",
      },
      departmentName: "",
      departmentId: "",
      roleName: "",
      roleId: "",
      mobileFlag:true,//密码框是否显示
    };
  },
  created() {},
  watch:{
    // 监听手机号是不是11位的，11位的时候调接口看看是否设置过密码
    'dataList.mobile':{
      handler: function(value) {
        let that = this
        if(value.length === 11){
          http.get(apiData.isVerifyPwd, true, {'mobile':value}, (res) => {
            if (res.data.code == 200) {
              that.mobileFlag = res.data.data.verify
            }
          })
        }
      },
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    urrentChange({row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, triggerRadio, triggerCheckbox, $event }) {
      // let selectRow = this.$refs.xTree.getRadioRecord()//获取选中
      // console.log( $event,row, triggerRadio)
    },
    radioChangeEvent({ row }) {
      let _this = this;
      this.selectRow = row
      _this.departmentNameTemp =  row.name
      _this.departmentIdTemp =  row.id
      //蒙层消失
    },
    getSearchList() {
      var _this = this;
      if (_this.name || _this.level) {
        _this.tapTable = 2;
        var params = {
          pageNum: _this.currentPage,
          pageSize: _this.pageSize,
          name: _this.name,
        };
        http.get(apiData.companyList, true, params, function (res) {
          if (res.data.code == 200) {
            if (res.data.data) {
              _this.tableData.data = res.data.data.list;
              _this.totalRow = res.data.data.totalRow;
              _this.$nextTick(() => _this.$refs.xTrees.setAllTreeExpand(true));
            } else {
            }
          } else {
            _this.$message.error(res.data.msg);
          }
        });
      } else {
        _this.tapTable = 1;
        _this.getList();
      }
    },
    getList: function () {
      var _this = this;
      var params = {
        pageNum: _this.currentPage,
        pageSize: _this.pageSize,
        parentId: _this.parentId,
        name: _this.name,
        level: _this.level,
      };

      http.get(apiData.companyList, true, params, function (res) {
        if (res.data.code == 200) {
          if (res.data.data) {
            _this.tableData.data = res.data.data.list;
            _this.totalRow = res.data.data.totalRow;
            console.log(_this.tableData.data, 123);
            for (let i = 0; i < _this.tableData.data.length; i++) {
              if (_this.tableData.data[i].sonNum >= 1) {
                _this.tableData.data[i].hasChild = true;
              } else {
                _this.tableData.data[i].hasChild = false;
              }
            }
          } else {
          }
        } else {
          _this.$message.error(res.data.msg);
        }
      });
    },
    loadChildrenMethod(row) {
      var _this = this;
      var id = row.row.id;
      var params = {
        parentId: id,
      };
      return new Promise((resolve, reject) => {
        // console.log(params)
        _this.parentId = id;

        http.get(apiData.companyList, true, params, function (res) {
          var tableData = res.data.data.list;
          if (res.data.data.list.length) {
            for (let i = 0; i < tableData.length; i++) {
              if (tableData[i].sonNum == 0) {
                tableData[i].hasChild = false;
                // console.log(tableData[i].hasChild,'展开后的数据')
              }
            }
            resolve(tableData);
            console.log("数组长度", tableData);
          } else {
            resolve([]);
            _this.$message.warning("当前节点没有下级！");
          }
          _this.parentId = "";
        });
      })
        .then((res) => {
          console.log(res);
          return res;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadChildrenMethod1(row) {
      var _this = this;
      var id = row.row.id;
      var params = {
        parentId: id,
        name: _this.name,
        level: _this.level,
      };
      _this.parentId = id;
      return new Promise((resolve, reject) => {
        _this.parentId = id;
        http.get(apiData.companyList, true, params, function (res) {
          var tableData = res.data.data.list;
          if (res.data.data.list.length) {
            for (let i = 0; i < tableData.length; i++) {
              if (tableData[i].sonNum == 0) {
                tableData[i].hasChild = false;
                console.log(tableData[i].hasChild);
              }
            }
            resolve(tableData);
            console.log("数组长度", tableData);
          } else {
            _this.$message.warning("当前节点没有下级！");
          }
          _this.parentId = "";
        });
      })
        .then((res) => {
          console.log(res);
          return res;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    isLeafFunc(data, node) {
      console.log(data);
      return data.hasChild ? false : true;
    },
    // 搜索部门
    // searchTreeParment() {
    //   let _this = this;
    //   var params = {
    //     pageNum: _this.currentPage,
    //     pageSize: _this.pageSize,
    //     name: _this.name,
    //   };
    //   http.get(apiData.companyList, true, params, function (res) {
    //     // _this.parentList = [];
    //     _this.items = res.data.data.list;
    //     _this.$nextTick(function () {
    //       _this.treeKey = +new Date();
    //       _this.isExpandAll = true;
    //       return;
    //     });
    //     // return _this.resolve(res.data.data.list)
    //   });
    // },
    loadNode(node, resolve, isSearch) {
      let _this = this;
      _this.showTree = true;
      if (node && node.level === 0) {
        _this.chooseNode = node; // 当前节点
        _this.lazy = true; // 当前节点
        _this.resolve = resolve;
      } else if (node && node.level > 0) {
        _this.parentId =
          node.data && node.data.id && node.data.id.length ? node.data.id : "";
      } else {
        _this.parentId = "";
      }
      var params = {
        pageNum: _this.currentPage,
        pageSize: _this.pageSize,
        parentId: _this.parentId,
        name: isSearch ? _this.name : "",
      };
      http.get(apiData.companyList, true, params, function (res) {
        if (isSearch) {
          _this.showTree = false;
          _this.parentList = [];
          _this.items = res.data.data.list;
          _this.isExpandAll = true;
          _this.$nextTick(function () {
            // _this.treeKey = +new Date();
            _this.isExpandAll = true;
          });
          return _this.resolve(res.data.data.list);
        } else {
          _this.parentList = res.data.data.list;
          return resolve(res.data.data.list);
        }
      });
    },
    // 根据手机号调接口看看是否设置过密码
    isVerifyPwd(params) {
      let that = this;
      http.get(apiData.isVerifyPwd, true, { mobile: params }, (res) => {
        if (res.data.code == 200) {
          that.mobileFlag = res.data.data.verify;
        }
      });
    },
    //保存
    addNumberInfo() {
      let _this = this;
      let params = _this.dataList;
      let val = this.$refs.number.value;
      console.log(val);
      // if (val != "") {
      http.post(apiData.addNumber, true, params, (res) => {
        if (res.data.code == 200) {
          _this.$router.go(-1);
        }
      });

      // } else {
      //   _this.$message.error("编号不能为空!");
      //   return;
      // }
    },
    // 搜索部门
    searchTreeParment() {
      let _this = this;
      console.log(_this.name);
      http.get(
        apiData.showParentList,
        true,
        { name: _this.name },
        function (res) {
          // console.log(res.data.data);
          if (res.data.code == 200) {
            // _this.parentList = res.data.data;
            _this.treeKey = +new Date();
            _this.isExpandAll = true
            _this.parentList = res.data.data
          }
        }
      );
    },

    // 搜索角色
    searchTreeRole() {
      let _this = this;
      // console.log(_this.name);
      http.get(
        apiData.showRoleList,
        true,
        { name: _this.name },
        function (res) {
          // console.log(res.data.data);
          if (res.data.code == 200) {
            _this.roleList = res.data.data;
          }
        }
      );
    },
    // 显示选择部门树形控件
    showDisappearDepart() {
      let _this = this;
      _this.btnType = 0;
      _this.disabledList = document.getElementsByClassName("none");
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "block";
      }
      // // 请求部门列表
      // http.get(apiData.showParentList, true, {}, function (res) {
      //   // console.log(res.data.data);
      //   _this.parentList = res.data.data;
      // });
    },
    // 显示选择角色树形控件
    showDisappearRole() {
      let _this = this;
      _this.btnType = 1;
      _this.disabledList = document.getElementsByClassName("none");
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "block";
      }
      // 请求角色列表
      http.get(apiData.showRoleList, true, {}, function (res) {
        // console.log(res.data.data);
        _this.roleList = res.data.data;
      });
    },
    clearParent(type) {
      if (type == 'role') {
        this.checkedId = ''
        this.$set(this.dataList, "roleName",'');
        this.$set(this.dataList, "roleId", '');
      } else {
        this.arraynum = []
        this.$set(this.dataList, "departmentName", '');
        this.$set(this.dataList, "departmentId", '');
        if (this.tapTable == '1') {
          this.$refs.xTree.clearRadioRow()
        }else if(this.tapTable == '1') {
          this.$refs.xTrees.clearRadioRow()
        }
        this.name = "";
      }
    },
    submitData1() {
      let _this = this;
      //蒙层消失
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "none";
      }
      this.$set(this.dataList, "departmentName", _this.departmentNameTemp);
      this.$set(this.dataList, "departmentId", _this.departmentIdTemp);
      _this.name = "";
    },
    submitData2() {
      let _this = this;
      //蒙层消失
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "none";
      }
      _this.dataList.roleName = _this.roleName;
      _this.dataList.roleId = _this.roleId;
      _this.name = "";
    },
    disappear() {
      let _this = this;
      //蒙层消失
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "none";
      }
      _this.name = "";
    },
    //@check-change实现单选
    // handleNodeClick1(data, checked, node) {
    //   let _this = this;
    //   console.log(data, checked, node);
    //   if (checked === true) {
    //     this.checkedId = data.id;
    //     this.$nextTick(() => {
    //       this.$refs.treeForm.setCheckedNodes([data]);
    //     });

    //     _this.departmentName = data.name;
    //     _this.departmentId = data.id;
    //   } else {  
    //     if (this.checkedId == data.id) {
    //       this.checkedId = "";
    //       _this.departmentName = "";
    //       _this.departmentId = "";
    //     }
    //   }
    // },

    handleNodeClick2(data, checked, node) {
      let _this = this;
      console.log(data, checked, node);

      if (checked === true) {
        _this.checkedId = data.id;
        this.$nextTick(() => {
          this.$refs.treeForm.setCheckedNodes([data]);
        });

        _this.roleName = data.name;
        _this.roleId = data.id;
      } else {
        if (this.checkedId == data.id) {
          this.checkedId = "";
          _this.roleName =''
        _this.roleId = ''
        }
      }
    },
    // 获取树形选中节点

    //选择上级单位

    retSuper() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="less">
.el-icon-search,
#close {
  cursor: pointer;
}
.vxe-button.type--text:not(.is--disabled):focus {
  box-shadow: none;
}

.content {
  text-align: left;
  .title {
    width: 100%;
    height: 56px;
    line-height: 56px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-indent: 10px;
    float: left;
  }

  .form {
    .form_item {
      display: flex;
      width: 100%;
      height: 40px;
      font-size: 14px;
      line-height: 40px;
      text-indent: 10px;

      input {
        width: 200px;
        height: 30px;
        margin-top: 5px;

        background: transparent;
        border: 1px solid rgb(204, 204, 204);
        text-indent: 10px;
      }
      .btn {
        width: 50px;
        color: #6cbef6;
        cursor: pointer;
        &.clear {
          width: 40px;
          margin-left: -12px;
        }
      }
      .radio {
        line-height: 40px;
        .el-radio {
          margin: 0;
        }
      }
      .xing-huang {
        color: #ffba1a;
      }
      .xing-lv {
        color: #55c4b8;
      }
    }

    .item_name {
      width: 160px;
      display: block;
      color: #666;
      padding-left: 10px;
    }

    .form_item:nth-child(odd) {
      background: #f8f8f8;
    }
  }
}
.layyer {
  width: 420px;
  height: 300px;
}
.closeBtn {
  width: 420px;
  height: 30px;
  display: contents;
  color: #fff;
  background: #55c4b8;
}

.el-row {
  text-align: center;
  height: 40px;
  width: 100%;
  margin: 200px 0;
}

.btnret:hover {
  background: #55c4b8;
  color: #f8f8f8;
}
.el-button:hover {
  background: #55c4b8;
  border: 1px solid #55c4b8;
  color: #f8f8f8;
}
.el-button {
  width: 200px;
  height: 40px;
  border: 1px solid #55c4b8;
  color: #55c4b8;
}

.btnSty {
  background: #55c4b8;
  color: #fff;
}
.btnSty:hover {
  background: #55c4b8;
  color: #fff;
  border: 1px solid #55c4b8;
}
.mask {
  width: 100%;
  height: 980px;
  position: absolute;
  top: 0;
  display: none;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
}

/* 弹框 */
.ec_tip {
  width: 460px;
  height: 600px;
  display: none;
  position: absolute;
  left: 40%;
  top: 100px;
  background: #f8f8f8;
  color: #fff;
  z-index: 999;
}

.ec-title {
  width: 100%;
  height: 40px;
  background-color: #75c0b6;
  text-align: center;
  line-height: 40px;
  position: relative;
}

.ec-title span {
  width: 20px;
  height: 20px;
  display: block;
  line-height: 16px;
  border: 1px solid #fff;
  border-radius: 50%;
  float: right;
  margin: 10px 10px 0 0;
}

.ec-but {
  position: absolute;
  bottom: 15px;
  margin: 0 auto;
}

.ec-but input {
  width: 200px;
  height: 40px;
  margin-left: 128px;
  float: left;
  border-radius: 5px;
  background-color: #fff;
}
.ec-cont {
  padding: 20px 0 0 20px;
  color: #000;
  display: flex;
  margin-left: 15px;
  input {
    width: 363px;
    height: 30px;
    padding: 4px 6px 4px 5px;
    border: 1px solid #ccc;
    text-align: center;
  }
  i {
    width: 30px;
    height: 30px;
    font-size: 25px;
    margin-top: 2px;
    display: block;
    margin-left: 5px;
    color: #ccc;
  }
}
.endTime_tr {
  float: left;
}
.tree {
  margin-top: 15px;
}
.el-tree {
  height: 420px;
  overflow-x: hidden;
}

.ec-but input:first-child {
  color: #fff;
  background-color: #75c0b6;
  border: 1px solid #75c0b6;
}

.active {
  background-color: #eee;
}
</style>
